var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxForm',{attrs:{"show-colon-after-label":false}},[_c('DxGroupItem',[_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('Searcher.observations.name'),"editor-options":{
        onValueChanged: _vm.onChangeName,
      }}}),_vm._v(" "),_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('Searcher.observations.latitude'),"editor-options":{
        onValueChanged: _vm.onChangeLatitude,
        value: parseFloat(_vm.currentPoint.latitude).toFixed(6),
        readOnly:true,
      }}}),_vm._v(" "),_c('DxSimpleItem',{attrs:{"data-field":_vm.$t('Searcher.observations.longitude'),"editor-options":{
        onValueChanged: _vm.onChangeLongitude,
        value: parseFloat(_vm.currentPoint.longitude).toFixed(6),
        readOnly:true,
      }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }